import { useCallback, useRef } from 'react';

import UserIcon from '@mui/icons-material/PersonRounded';
import { generatePath } from 'react-router-dom';

import { useAccountExperience } from '#client/hooks/useAccountExperience';

import { getUserMenuConfig } from './config';
import { MenuItem as UserMenuItem } from './MenuItem';
import { UserInfo } from './UserInfo';
import { UserMenuButton, UserMenuContainer, UserMenuList } from './UserMenu.style';
import useAnchorElement from '../../hooks/useAnchorElement';

function UserMenu() {
  const buttonRef = useRef(null);
  const menuRef = useRef(null);
  const { anchorElement, onButtonClick, onMenuClose } = useAnchorElement(menuRef, buttonRef);
  const open = Boolean(anchorElement);

  const { accountExperience } = useAccountExperience();
  const { chrome } = accountExperience;
  const userMenuItems = getUserMenuConfig(chrome.userMenuId);

  // Prevent the menu from closing when clicking the scrollbar
  const onMenuBlur = useCallback((e) => {
    if (e.relatedTarget && menuRef.current.contains(e.relatedTarget)) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      onMenuClose();
    }
  }, [onMenuClose]);

  return (
    <>
      <UserMenuButton
        aria-controls="user-menu"
        aria-haspopup="true"
        clickstreamProps={{
          elementName: 'user_menu_button',
          elementStyle: 'icon'
        }}
        label="User menu"
        icon={<UserIcon color="inherit" />}
        onClick={onButtonClick}
        ref={buttonRef}
        variant="text"
        open={open}
      />

      <UserMenuContainer
        id="user-menu"
        ref={menuRef}
        anchorEl={anchorElement}
        onBlur={onMenuBlur}
        onClose={onMenuClose}
        open={open}
      >
        <UserInfo />

        <UserMenuList>
          {userMenuItems.map((menuItem) => (
            <UserMenuItem
              divider={menuItem.divider}
              icon={menuItem.icon}
              key={menuItem.id}
              onClick={onMenuClose}
              title={menuItem.title}
              to={generatePath(menuItem.path)}
            />
          ))}
        </UserMenuList>
      </UserMenuContainer>
    </>
  );
}

export default UserMenu;
